<template>
  <div class="shoppe">
    <el-button type="primary" @click="addDialog" plain>添加</el-button>
    <el-table :data="tableData">
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="name" label="组名"> </el-table-column>
      <el-table-column prop="infos.0.vendorName" label="店铺1">
      </el-table-column>
      <el-table-column prop="infos.1.vendorName" label="店铺2">
      </el-table-column>
      <el-table-column prop="infos.2.vendorName" label="店铺3">
      </el-table-column>
      <el-table-column prop="infos.3.vendorName" label="店铺4">
      </el-table-column>
      <el-table-column prop="infos.4.vendorName" label="店铺5">
      </el-table-column>
      <el-table-column prop="infos.5.vendorName" label="店铺6">
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-link
            type="primary"
            style="margin-right: 8px"
            @click="editDialog(scope.row)"
            >编辑</el-link
          >
          <el-link type="danger" @click="removeItem(scope.row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-button class="mt10" type="primary" @click="submit">保存</el-button> -->
    <el-dialog
      :title="titleName"
      :visible.sync="dialogVisible"
      append-to-body
      width="620px"
      :before-close="handleClose"
    >
      <el-form label-width="80px" ref="form" :model="form" :rules="rules">
        <el-form-item label="组名：" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="店铺：" prop="vendorIds">
          <BrandSelect
            :data="vendorList"
            v-model="form.vendorIds"
            filterable
            clearable
            multiple
            collapse-tags
            :multiple-limit="6"
          ></BrandSelect>
          <div>
            <el-tag
              v-for="tag in getVendorTags(form.vendorIds)"
              :key="tag.label"
              style="margin: 10px 10px 0 0"
              closable
              @close="closeTag(tag.value)"
            >
              {{ tag.label }}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item style="margin-top: 60px; text-align: right">
          <el-button type="" @click="handleClose">取消</el-button>
          <el-button type="primary" @click="submitDialog">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRelationVendorList,
  getVendorRelationList,
  saveVendorRelationList,
  deleteVendorRelation,
  getRelationList,
  saveOrUpdateRelation,
  deleteRelation,
} from "./api";
import BrandSelect from "@/views/components/brandSelect.vue";

export default {
  components: { BrandSelect },
  data() {
    return {
      vendorList: [],
      vendorMap: {},
      tableData: [],
      titleName: "",
      dialogVisible: false,
      form: {
        name: "",
        vendorIds: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入组名",
            trigger: "blur",
          },
        ],
        vendorIds: [
          {
            required: true,
            message: "请选择店铺",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {},
  async mounted() {
    var res = await getRelationVendorList();
    if (res.data) {
      this.vendorList = res.data.map((item) => {
        return {
          label: item.vendorName,
          value: item.vendorId,
        };
      });
      const map = {};
      const nameMap = {};
      res.data.forEach((item) => {
        map[item.vendorId] = item.vendorName;
        nameMap[item.vendorName] = item.vendorId;
      });
      this.vendorMap = map;
      this.vendorNameMap = nameMap;
    }
    this.getTableData();
  },
  beforeDestroy() {},
  methods: {
    getTableData() {
      getRelationList().then((res) => {
        if (res.success && res.data) {
          this.tableData = res.data.map((item) => {
            let infos = [];
            infos = item.vendorIds.map((vendorId) => ({
              vendorId,
              vendorName: this.vendorMap[vendorId],
            }));
            if (infos.length < 6) {
              infos = infos.concat(
                new Array(6 - infos.length).fill(null).map(() => ({
                  vendorId: null,
                  vendorName: null,
                }))
              );
            }
            return {
              ...item,
              infos,
            };
          });
        }
      });
    },
    removeItem(row) {
      this.$confirm(`确认删除吗`, "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteRelation({
            id: row.id,
          }).then((res) => {
            if (res.data.success) {
              this.getTableData();
            } else {
              this.$message.error(res.data.message || "系统异常，请稍后再试");
            }
          });
        })
        .catch(() => {});
    },
    getVendorTags(vendorIdList) {
      return (
        this.vendorList.length &&
        this.vendorList.filter((item) => vendorIdList.includes(item.value))
      );
    },
    closeTag(id) {
      const index = this.form.vendorIds.findIndex((item) => item === id);
      index > -1 && this.form.vendorIds.splice(index, 1);
    },
    addDialog() {
      this.titleName = "新增";
      this.$nextTick(() => {
        this.dialogVisible = true;
        this.form = {
          name: "",
          vendorIds: [],
        };
      });
    },
    editDialog(row) {
      this.titleName = "编辑";
      this.$nextTick(() => {
        this.dialogVisible = true;
        this.form = {
          id: row.id,
          name: row.name,
          vendorIds: [],
        };
        setTimeout(() => {
          this.form.vendorIds = [...row.vendorIds];
        }, 200);
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.clearValidate();
    },
    async submitDialog() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) return;
        var params = this.form;
        var res = await saveOrUpdateRelation(params);
        if (res.data.success) {
          this.$message.success("提交成功");
          this.handleClose();
          this.getTableData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.mt10 {
  margin-top: 10px;
}
.item-cell:active {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
